import React from 'react'

export const Gms = (props) => {
  return (
    <div>
        <div>
            <a href="/home">
                    <i className='bi bi-house-door'></i>
            </a>
        </div>
    </div>
  )
}

